<template>
    <div class="entity-form" @click="(e)=>{e.stopPropagation()}">
        <form @submit.prevent="(e)=>{e.stopPropagation()}" v-if="custlist !== null">
            <div class="form-heading">
                <div v-if="line_type === 1" class="form-title">{{$t('form.orderlist.heading',[custlist?.lines?.filter(line=> line.productTypeId === line_type).length ?? '0'])}}</div>
                <div v-if="line_type === 2" class="form-title">{{$t('form.orderlist.headingHostGift',[custlist?.lines?.filter(line=> line.productTypeId === line_type).length ?? '0'])}}</div>
                <div v-if="line_type === 13" class="form-title">{{$t('form.orderlist.headingElevatedHostGift',[custlist?.lines?.filter(line=> line.productTypeId === line_type).length ?? '0'])}}</div>


                <button  class="button-primary button-primary__oraange button-primary__thin" @click="cancelForm" >{{$t('form.participant.done')}}</button>
            </div>

            <div class="flex-column" style="margin-top: 16px; padding: 6px;">
                <div><CategoryList mode="party"
                                   :custlist="custlist"
                                   :line_type="line_type"
                                   @add-to-cart-clicked="addToCartClicked"
                                   @remove-from-cart-clicked="removeFromCartClicked"
                                   @make-reservation-clicked="makeReservationClicked"
                                   @release-reservation-clicked="releaseReservationClicked"
                /></div>
            </div>
         </form>
         <Spinner v-else/>
    </div>
</template>

<script>
 import * as types from '@/store/mutations'
 import { nextTick } from 'vue'
 import CategoryList from "../lists/CategoryList"
 import Spinner from "@/components/core/Spinner.vue";

 export default {
     name: "OrderListForm",
     components: {Spinner, CategoryList},
     data() {
         return {
             filtered:'',
             partyId:-1,
             line_type:1,
             custlist:null
         }
     },

     props: {
         reference: {
             type: [ Number ],
             default:-1
         },
         for_linetype: {
             type: [ Number],
             default:1
         }
     },
     computed:{

     },

     mounted(){
         if(this.reference > 0){
             this.partyId = this.reference
         }
         this.$store.dispatch('loadAllProducts').then(()=>{
             this.$store.dispatch('getCustomerOrderlist', this.reference).then((res)=>{
                 //console.log(res)
                 this.custlist = res
                 this.line_type = this.for_linetype
             }).catch(()=>{

             })
         })

     },
     methods: {
         submitParty(){

         },
         cancelForm(){
             this.$emit('form-closed')
             // this.$router.go({name: 'Party', params: {id: this.reference}})
         },
         partyHasParticipant(party,custId){
             if(party === null){
                 return false;
             }
             let participantParty = party?.customerOrders?.filter((cust)=>{ return parseInt(cust.personId) == parseInt(custId )}) ?? []

             if(participantParty.length > 0){
                 return true;
             }  else {
                 return false;
             }
         },
         customerClicked(custId){
             //console.log(custId)


             if(!this.partyHasParticipant(this.party, custId)){
                 this.$store.commit(types.START_ADDING_PARTICIPANT, custId)
                 this.$store.dispatch('addParticipant', {personId:custId,partyId:this.reference}).then(()=>{
                     this.$store.dispatch('loadParty', this.reference).then((res)=>{
                         this.party = res[0]
                     }).catch(()=>{

                     }).finally(()=>{
                         nextTick(()=>{
                             this.$store.commit(types.DONE_ADDING_PARTICIPANT, custId)
                         })
                     })
                 })
             }


         },
         addToCartClicked(custId, sku){
             this.$store.dispatch('addProductToWoc',{personId:custId, sku:sku,line_type:this.for_linetype}).then(()=>{
                 //console.log(this.for_linetype)
                 this.$store.dispatch('getCustomerOrderlist', this.reference).then((res)=>{
                     //console.log(res)
                     this.$store.dispatch('loadParty', res.partyId).then(()=>{

                     })
                     this.custlist = res
                     this.$store.dispatch('loadProductStock')

                     this.$store.dispatch('loadOpenOrder' ).then((res)=>{
                         this.emitter.emit('custlist_updated',res)

                     })
                 }).catch(()=>{

                 })
             })
         },
         async makeReservationClicked(custId, lineId){

             //find line
             //


             await this.$store.dispatch('makeReservation', {custId: custId, lineId:lineId})
             let cart = await this.getUpdatedCustomerOrderlist(custId)
             await this.$store.dispatch('loadParty', cart.partyId)
         },

         async releaseReservationClicked(custId, lineId){
             await this.$store.dispatch('releaseReservation', {custId: custId, lineId: lineId})
             let cart = await this.getUpdatedCustomerOrderlist(custId)
             await this.$store.dispatch('loadParty', cart.partyId)
         },
         async getUpdatedCustomerOrderlist(custListId){
             if(!custListId) {
                 return
             }
             try{
                 let custlist = await this.$store.dispatch('getCustomerOrderlist', custListId)
                 //   this.custlist = custlist
                 //     this.custToggled = this.custlist.directDelivery === 1
                 ///    this.count += 1
                 //   this.custlistLoading = false
                 this.custlist = custlist
                 return custlist
             } catch(err) {
                 // this.custlistLoading = false
                 console.log('getUpdatedCustomerOrderlist failed:', err)
             }
         },
         removeFromCartClicked(custId, sku){
             this.$store.dispatch('removeProductFromWoc',{personId:custId, sku:sku,line_type:this.for_linetype}).then(()=>{
                 this.$store.dispatch('getCustomerOrderlist', this.reference).then((res)=>{
                     //console.log(res)
                     this.$store.dispatch('loadProductStock')

                     this.$store.dispatch('loadParty', res.partyId).then(()=>{

                     })
                     this.custlist = res

                     this.$store.dispatch('loadOpenOrder' ).then((res)=>{
                         this.emitter.emit('custlist_updated',res)

                     })


                 }).catch(()=>{

                 })
             })
         }
     }
 }
</script>

<style scoped>

</style>
